(function () {
  'use strict';

  var FIRST_TOUCH_KEY = 'sj_first_touch_v1';
  var LAST_TOUCH_KEY = 'sj_last_touch_v1';

  function clean(value, limit) {
    return String(value || '').trim().slice(0, limit || 160);
  }

  function readStorage(storage, key) {
    try {
      var value = storage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Attribution must never interrupt storefront behaviour.
    }
  }

  function externalReferrer() {
    if (!document.referrer) return '';

    try {
      var url = new URL(document.referrer);
      if (url.hostname === window.location.hostname) return '';
      return clean(url.origin + url.pathname, 240);
    } catch (error) {
      return '';
    }
  }

  function referrerSource(referrer) {
    if (!referrer) return { source: '(direct)', medium: '(none)' };

    try {
      var host = new URL(referrer).hostname.replace(/^www\./, '').toLowerCase();

      if (/(^|\.)google\./.test(host)) return { source: 'google', medium: 'organic' };
      if (/(^|\.)bing\.com$/.test(host)) return { source: 'bing', medium: 'organic' };
      if (/(^|\.)yahoo\./.test(host)) return { source: 'yahoo', medium: 'organic' };
      if (/(^|\.)duckduckgo\.com$/.test(host)) return { source: 'duckduckgo', medium: 'organic' };

      return { source: host, medium: 'referral' };
    } catch (error) {
      return { source: '(direct)', medium: '(none)' };
    }
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search);
    var referrer = externalReferrer();
    var inferred = referrerSource(referrer);
    var source = clean(params.get('utm_source') || inferred.source);
    var medium = clean(params.get('utm_medium') || inferred.medium);
    var campaign = clean(params.get('utm_campaign') || '(not set)');

    return {
      source: source || '(direct)',
      medium: medium || '(none)',
      campaign: campaign || '(not set)',
      landing: clean(window.location.pathname, 240),
      referrer: referrer,
      capturedAt: new Date().toISOString()
    };
  }

  function hasNewAttributionSignal() {
    var params = new URLSearchParams(window.location.search);
    return Boolean(
      params.get('utm_source') ||
      params.get('utm_medium') ||
      params.get('utm_campaign') ||
      params.get('gclid') ||
      params.get('fbclid') ||
      externalReferrer()
    );
  }

  function cartAttributes(firstTouch, lastTouch) {
    return {
      'SJ first source': firstTouch.source,
      'SJ first medium': firstTouch.medium,
      'SJ first campaign': firstTouch.campaign,
      'SJ first landing': firstTouch.landing,
      'SJ first referrer': firstTouch.referrer,
      'SJ last source': lastTouch.source,
      'SJ last medium': lastTouch.medium,
      'SJ last campaign': lastTouch.campaign,
      'SJ last landing': lastTouch.landing,
      'SJ last referrer': lastTouch.referrer
    };
  }

  function syncAttributionToCart() {
    var current = currentTouch();
    var firstTouch = readStorage(window.localStorage, FIRST_TOUCH_KEY);
    var lastTouch = readStorage(window.sessionStorage, LAST_TOUCH_KEY);

    if (!firstTouch) {
      firstTouch = current;
      writeStorage(window.localStorage, FIRST_TOUCH_KEY, firstTouch);
    }

    if (!lastTouch || hasNewAttributionSignal()) {
      lastTouch = current;
      writeStorage(window.sessionStorage, LAST_TOUCH_KEY, lastTouch);
    }

    var attributes = cartAttributes(firstTouch, lastTouch);
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        var existing = cart.attributes || {};
        var changed = Object.keys(attributes).some(function (key) {
          return clean(existing[key], 240) !== clean(attributes[key], 240);
        });

        if (!changed) return null;

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function () {
        // Analytics support code must fail silently and never block shopping.
      });
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(syncAttributionToCart, { timeout: 1800 });
  } else {
    window.setTimeout(syncAttributionToCart, 1200);
  }
})();
